import React from 'react';
import { useAcombaBridgeStore } from '../../stores/acombaBridgeStore';
import { resolveBridgeCause } from '../../utils/bridge/bridgeCause';
import { getBridgeLaunchStatus } from '../../services/bridgeLaunchStatus';
import { BridgeCauseBanner } from './BridgeCauseBanner';
import { SessionReasonBanner } from './SessionReasonBanner';

/**
 * Shown in place of the whole app shell when useAcombaBridgeGate gives up automatically retrying —
 * two tiers of cause, same as BridgeWizard: the bridge process itself unreachable/stopped/stale
 * (BridgeCauseBanner) or the bridge is up but the session isn't connected — no SDK, wrong version, or
 * a plain not-connected/reconnect-from-Acomba case (SessionReasonBanner). Reuses both banners verbatim
 * rather than re-authoring their copy for a third time.
 *
 * No retry action here — the message already says what to do (reopen ComptabilitéAI from Acomba), and
 * a redundant in-app button next to it read as two competing calls to action.
 */
export const AcombaBridgeBlockedScreen: React.FC = () => {
    const bridgeStatus = useAcombaBridgeStore((s) => s.bridgeStatus);
    const bridgeInfo = useAcombaBridgeStore((s) => s.bridgeInfo);

    const cause = resolveBridgeCause(bridgeStatus === 'reachable', bridgeInfo, getBridgeLaunchStatus());

    return (
        <div data-testid="acomba-bridge-blocked" className="flex min-h-screen items-center justify-center bg-surface px-xl">
            {/* Matches the app's normal content width (RootLayout) rather than a narrow card — the
                message wraps mid-sentence at max-w-md. */}
            <div className="w-full max-w-content">
                {cause !== 'connected'
                    ? <BridgeCauseBanner cause={cause} centered />
                    : <SessionReasonBanner centered />}
            </div>
        </div>
    );
};
